import { Stack } from '@fluentui/react';
import React, { useEffect } from 'react';

// assets

import { useStore } from '../../../stores/root';
import TrucksList from '../../../components/operationals/trucks/general/list';
import { faHome } from '@fortawesome/pro-light-svg-icons';

interface ITrucksListPageProps {
}

const TrucksListPage: React.FC<ITrucksListPageProps> = (props: ITrucksListPageProps) => {
    const {topbar} = useStore();

    useEffect(() => {
        topbar.show("Trucks", [
            {key: "home", icon: faHome, href: "/"},
            {key: "operationals", text: 'Operationals'},
            {key: "trucks", text: 'Trucks'}
        ])
    }, []);

    return <Stack>
        <TrucksList />
    </Stack>;
};

export default TrucksListPage;
